// extracted by mini-css-extract-plugin
export default {"background":"admin_background__kSAql","buttonContainer":"admin_buttonContainer__aGSDs"};